import { Plugin, PluginKey } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

const key = new PluginKey('input-placeholder-plugin');

const getInputPlaceholderPlugin = (text: string) => {
  return [
    new Plugin({
      key,
      props: {
        decorations: (state) => {
          const doc = state.doc;
          const hasNoChildren = doc.childCount === 0;
          const isEmptyTextBlock =
            doc.childCount === 1 &&
            doc.firstChild?.isTextblock &&
            doc.firstChild?.content.size === 0 &&
            doc.firstChild.type.name === 'paragraph';

          if (hasNoChildren || isEmptyTextBlock) {
            const placeholder = document.createElement('span');
            placeholder.classList.add('placeholder');
            placeholder.setAttribute('data-placeholder', text);

            return DecorationSet.create(doc, [Decoration.widget(0, placeholder)]);
          }
        },
      },
    }),
  ];
};

export default getInputPlaceholderPlugin;
